import { mobileThemeService } from '../../../../services/theme/MobileThemeService';
import AppAction from 'action/appAction';

export class LearnersLoader {

  static Layout;

  static async load(callback) {
    if (!LearnersLoader.Layout) {
      AppAction.toggleGlobalSpinner(true);
    }

    if (mobileThemeService.includeTheme(mobileThemeService.THEMES.THEME_TO_BUILD_A_PROFILE_LEARNERS)) {
      await import(/* webpackChunkName: "2bap-learners-theme" */ '2bap-learners/index.less');
    }

    if (!LearnersLoader.Layout) {
      const moduleLayout = await import(/* webpackChunkName: "2bap-learners-module-layout" */ './layouts/ModuleLayout');
      // eslint-disable-next-line require-atomic-updates
      LearnersLoader.Layout = moduleLayout.ModuleLayout;
      AppAction.toggleGlobalSpinner(false);
    }

    callback(null, LearnersLoader.Layout);
  }

}
